import { NodeType } from '@amplify/amp-module';
import embeddedStore from './embedded-store';
import InsightsNodeHandler from '../insights-node-handler';

export default class EmbedHandler extends InsightsNodeHandler {
  constructor(ctx, nodeType = NodeType.embedded) {
    super(ctx, nodeType);
    if (!embeddedStore.registered) {
      this.store.registerModule('embeddedStore', embeddedStore);
      embeddedStore.registered = true;
    }
  }

  async handleNode(node, options = {}) {
    this.store.dispatch('embeddedStore/embedCompleted', false);
    this.store.dispatch('embeddedStore/setIsOpened', true);

    this.trackResponseEvent('embedded', {
      embeddedId: node.id,
      stateType: 'OPEN',
    });

    await super.handleNode(node, { ...options, handleStorage: false });

    if (this.unwatch) {
      this.unwatch();
    }

    const successEventCallback = (e) => {
      if (e.data.event === node.successMessageEvent) {
        if (node.storage) this.store.dispatch('chatbotStore/addToStorage', { key: node.storage, data: true });
        this.store.dispatch('embeddedStore/embedCompleted', true);
        window.removeEventListener('message', successEventCallback);
        if (node.returnOnSuccess) {
          this.store.dispatch('embeddedStore/setIsOpened', false);
          this.trackResponseEvent('embedded', {
            embeddedId: node.id,
            stateType: 'CLOSE',
            statusType: 'TRUE',
          });
        }
      }
    };

    if (node.storage) {
      // Setting default storage value
      this.store.dispatch('chatbotStore/addToStorage', { key: node.storage, data: false });
    }

    if (node.successMessageEvent) {
      window.addEventListener('message', successEventCallback);
    }

    const result = new Promise((resolve) => {
      this.unwatch = this.store.watch(
        (state) => state.embeddedStore.isOpened,
        (newValue) => {
          if (!newValue) {
            this.unwatch();
            window.removeEventListener('message', successEventCallback);
            resolve(this.store.getters['chatbotStore/nextNode'](node.id));
          }
        }
      );
    });

    return result;
  }
}
